import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { getApiDataService } from "../../../services/apiServices";
import { APP_GUIDE_API } from "../../../services/CONSTANTS";

function CreateAppGuide(props) {
  // Initialize state with default values for accountName, accountNo, and status
  const [preview, setPreview] = useState(null);
  const [name, setName] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  // Handler functions for updating account information

  const handleNameChange = (e) => {
    if (
      e.target.files[0].type === "image/jpeg" ||
      e.target.files[0].type === "image/png" ||
      e.target.files[0].type === "image/jpg"
    ) {
      let imgReview = e.target.files[0];
      console.log(imgReview);
      if (imgReview) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreview(reader.result);
        };
        reader.readAsDataURL(imgReview);
      } else {
        setPreview(null);
      }
      setName(e.target.files[0]);
    } else {
      alert("This is only accept image files! Thanks");
      setName(null);
      return;
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    let data = {
      image: name,
    };
    props.onSubmit(data);
  };

  return (
    <Modal isOpen={true} toggle={props.onClose}>
      <ModalHeader toggle={props.onClose}>Create Banner </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="name">Image</Label>
            <Input
              type="file"
              accept="image/jpeg, image/png, image/jpg"
              name="name"
              id="name"
              onChange={handleNameChange}
            />
          </FormGroup>
          {preview && <img src={name} alt="" style={{ width: "100px", height: "100px" }} />}
        </Form>
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-default" onClick={props.onClose}>
          No
        </button>
        {isLoading == false && (
          <button className="btn btn-success" onClick={handleSubmit}>
            Save
          </button>
        )}
        {isLoading == true && (
          <button className="btn btn-success" disabled="disabled">
            Uploading...
          </button>
        )}
      </ModalFooter>
    </Modal>
  );
}

export default CreateAppGuide;
